import { hasVitalsOnConsultation, NURSING_STATUS } from '../../../constants/nursingStatus';

export const NURSE_QUEUE_FILTERS = [
  { id: 'all', label: 'En cours' },
  { id: 'pending', label: 'À traiter' },
  { id: 'care', label: 'En soins' },
  { id: 'exam', label: 'En examen' },
  { id: 'done', label: 'Terminés' }
];

export function isNursingConsultation(consultation) {
  const line = String(consultation?.service_line || 'MEDICAL').toUpperCase();
  if (line === 'NURSING') return true;
  const ns = String(consultation?.nursing_status || '').toUpperCase();
  return ns === NURSING_STATUS.CLOSED || ns === NURSING_STATUS.TRANSFERRED_MEDICAL;
}

export function isQueueItemDone(consultation) {
  return classifyNursingQueueItem(consultation) === 'done';
}

/** Passage infirmerie encore actif (non clôturé, non annulé). */
export function isActiveNursingQueueItem(consultation) {
  if (!consultation) return false;
  if (consultation.status === 'CANCELLED') return false;
  return classifyNursingQueueItem(consultation) !== 'done';
}

/** Contenu saisi dans la rubrique Examen (pas les notes d'accueil). */
export function hasExamSectionContent(consultation) {
  if (!consultation) return false;
  if ((consultation.diseases?.length || 0) > 0) return true;
  if (String(consultation.disease_code || '').trim()) return true;
  return false;
}

export function classifyNursingQueueItem(consultation) {
  if (!consultation) return 'care';
  const ns = String(consultation.nursing_status || '').toUpperCase();

  if (
    ns === NURSING_STATUS.CLOSED ||
    ns === NURSING_STATUS.TRANSFERRED_MEDICAL ||
    consultation.status === 'CANCELLED' ||
    (String(consultation.service_line || '').toUpperCase() === 'NURSING' &&
      consultation.status === 'COMPLETED')
  ) {
    return 'done';
  }
  if (hasExamSectionContent(consultation)) return 'exam';
  if (
    hasVitalsOnConsultation(consultation) ||
    ns === NURSING_STATUS.IN_CARE ||
    ns === NURSING_STATUS.VITALS_RECORDED
  ) {
    return 'care';
  }
  return 'pending';
}

export function getQueueBucketLabel(bucketId) {
  return NURSE_QUEUE_FILTERS.find((filter) => filter.id === bucketId)?.label || bucketId;
}

export function passageSectionForQueueBucket(bucketId) {
  if (bucketId === 'exam') return 'exam';
  if (bucketId === 'care') return 'acts';
  return 'acts';
}

export function matchesNurseQueueFilter(consultation, filterId) {
  if (!isNursingConsultation(consultation)) return false;
  const bucket = classifyNursingQueueItem(consultation);
  if (!filterId || filterId === 'all') return bucket !== 'done';
  return bucket === filterId;
}

export function countByQueueFilter(consultations) {
  const nursing = (consultations || []).filter(isNursingConsultation);
  const counts = { all: 0, pending: 0, exam: 0, care: 0, done: 0 };
  nursing.forEach((c) => {
    const bucket = classifyNursingQueueItem(c);
    if (counts[bucket] !== undefined) counts[bucket] += 1;
    if (bucket !== 'done') counts.all += 1;
  });
  return counts;
}
